import { render } from "./BurgerMenu.vue?vue&type=template&id=36edda4e"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__